import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import ActionIcon from 'src/components/general/ActionIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlus } from '@fortawesome/free-solid-svg-icons';
import { DropdownList } from 'react-widgets';
import { NumericFormat } from 'react-number-format';
import { useForm } from 'react-hook-form';

export const PayrollNewConcepts = ({ 
    // Datos
    conceptListData,        // Lista de conceptos disponibles
    subConceptArray,        // Lista de subconceptos
    assetConcept,           // Concepto seleccionado
    subConcept,             // Subconcepto seleccionado
    item,                   // Item actual
    code,                   // Código actual
    salaryTemplate,         // Plantilla seleccionada
    disabledFields,         // Estado de deshabilitación
    messagesDropDown,       // Mensajes para dropdowns
    
    // Handlers
    handleChangeConcept,    // Manejador cambio concepto
    setSubConcept,
    setItem,
    setCode,
    addConcept,             // Manejador agregar concepto
}) => {
    const hookFormMethods = useForm();
    const { register } = hookFormMethods;

    // Verifica que los campos necesarios estén completos para agregar un concepto
    const isFigurativeFormValid = () => {
        const requiredFields = [
            { value: assetConcept, name: 'concepto' },
            { value: subConcept, name: 'subconcepto' },
            { value: item, name: 'item' },
            { value: code, name: 'código' },
        ];
        return requiredFields.every(field => Boolean(field.value));
    };

    // Valida que el codigo numerico no exceda un maximo
    const validateCodeInput = (input) => {
        const MAX_CODE_VALUE = 9999;
        const { value } = input;
        const isValid = value <= MAX_CODE_VALUE;
        return isValid ? input : undefined;
    };

    return (
        <>
            <Form.Group as={Row}>
                <Form.Label sm={4} className='text-black-color pr-0 d-flex mandatory-label' column>
                    Agregar concepto de Haberes:
                </Form.Label>
                <Col sm={4}>
                    <DropdownList
                        placeholder='Seleccione un concepto...'
                        data={conceptListData}
                        allowCreate='onFilter'
                        name='concept'
                        textField='description'
                        dataKey='id'
                        filter='contains'
                        className='w-100 text-black-color'
                        id='concept'
                        value={assetConcept}
                        messages={messagesDropDown}
                        onChange={(value) => handleChangeConcept(value?.id)}
                        selectIcon={
                            <FontAwesomeIcon
                                icon={faChevronDown}
                                className='text-black-color'
                            />
                        }
                        disabled={!salaryTemplate || disabledFields}
                    >
                    </DropdownList>
                </Col>
                <Col sm={4} className='offset-md-4 mt-3' >
                    <DropdownList
                        placeholder='Seleccione un subconcepto...'
                        data={subConceptArray}
                        allowCreate='onFilter'
                        name='subconcept'
                        textField='description'
                        dataKey='id'
                        filter='contains'
                        className='w-100 text-black-color'
                        id='subconcept'
                        value={subConcept}
                        messages={messagesDropDown}
                        onChange={(value) => setSubConcept(value?.id)}
                        selectIcon={
                            <FontAwesomeIcon
                                icon={faChevronDown}
                                className='text-black-color'
                            />
                        }
                        disabled={!salaryTemplate || disabledFields}
                    >
                    </DropdownList>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Col sm={4} className='offset-md-4'>
                    <Form.Control
                        type="text"
                        name="item"
                        ref={register}
                        placeholder="Item"
                        onChange={(event) => setItem(event?.target?.value)}
                        disabled={!salaryTemplate || disabledFields}
                        maxLength={255}
                    />
                </Col>
                <Col sm={4} className='offset-md-4 mt-3 py-0'>
                    <NumericFormat
                        value={code}
                        decimalScale={0}
                        inputMode='numeric'
                        className="form-control form-control-sm py-3"
                        placeholder={'Código'}
                        allowNegative={false}
                        allowLeadingZeros={false}
                        onValueChange={(event) => setCode(event?.value)}
                        isAllowed={(inputObj) => validateCodeInput(inputObj)}
                        disabled={!salaryTemplate || disabledFields}
                    />
                </Col>
                <ActionIcon
                    className='mt-3'
                    size='lg'
                    toolTipText="Agregar Concepto"
                    icon={faPlus}
                    disabled={!isFigurativeFormValid()}
                    onClick={addConcept}
                />
            </Form.Group>
        </>
    );
};